import { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import completed from "../../assets/images/completed.png";
import { connect } from "react-redux";

import { numberWithCommas } from "../../functions/utils";

class BusinessADHistoryComponent extends Component {
  state = {
    fixclaimid: "12",
    fixclaimreason: "",
    fixclaimmodal: false,
    remainingdates: 0,
  };

  handleOk = () => {
    this.setState({
      fixclaimmodal: false,
      fixclaimid: "",
    });
  };

  handleFixForClaim = (id) => {
    this.setState({
      fixclaimid: id,
      fixclaimmodal: true,
    });
  };

  handleCancel = () => {
    this.setState({
      fixclaimmodal: false,
      fixclaimid: "",
    });
  };

  componentDidMount() {
    if (!this.props.data.completed) {
      const asipdatee = this.props.adcard.controller.asipDate.toDate();

      const newdatea = new Date(
        asipdatee.setDate(asipdatee.getDate() + this.props.data.sda)
      );

      this.setState({
        remainingdates:
          new Date().setHours(0, 0, 0, 0) - newdatea.setHours(0, 0, 0, 0),
      });
    }
  }

  render() {
    return (
      <div
        className="item features-image сol-12 col-md-6 col-lg-6"
        onClick={() => {
          window.open(
            "/business_ad/" + this.props.data.id,
            "_blank" // <- This is what makes it open in a new window.
          );
        }}
      >
        <div className="item-wrapper">
          <div className="item-content">
            <div className="container">
              <div className="row">
                <div className="сol-8 col-md-8 col-sm-8">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Name
                  </p>
                  <h5 className="item-title mbr-fonts-style display-6">
                    <a
                      href={"/business_ad/" + this.props.data.id}
                      rel="noreferrer"
                      target="_blank"
                      className="text-primary"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <strong>{this.props.data.name}</strong>
                    </a>
                  </h5>
                </div>
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9 text-right">
                    {this.props.data.completed
                      ? "Current Status"
                      : "Remaining Balance"}
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7 text-right">
                    <strong
                      style={
                        this.props.data.completed
                          ? { color: "green" }
                          : { color: "black" }
                      }
                    >
                      {this.props.data.completed ? (
                        <div className="row">
                          <div className="col">
                            <span>Completed</span>
                          </div>
                          <div
                            style={{
                              width: "1.2rem",
                            }}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <img
                              src={completed}
                              style={{
                                width: "1.2rem",
                                height: "1.2rem",
                              }}
                              className="completed"
                              alt=""
                              title=""
                            />
                          </div>
                        </div>
                      ) : this.props.data.adCardBalance !== null &&
                        this.props.data.adCardBalance !== undefined ? (
                        numberWithCommas(
                          this.props.data.adCardBalance.toFixed(2)
                        ) + " ETB"
                      ) : (
                        "0.00 ETB"
                      )}
                    </strong>
                  </h5>
                </div>
              </div>

              <div className="row">
                <div className="сol-4 col-md-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Start Date
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.start_date !== null &&
                    this.props.data.start_date !== undefined
                      ? this.props.data.start_date.toDate().toDateString()
                      : "-"}
                  </h5>
                </div>
                <div className="сol-4 col-md-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    {this.props.data.completed ? "Final Date" : "Expire Date"}
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.end_date !== null &&
                    this.props.data.end_date !== undefined
                      ? this.props.data.end_date.toDate().toDateString()
                      : "-"}
                  </h5>
                </div>
                {!this.props.data.completed ? (
                  <div className="сol-4 col-md-4 ">
                    <p className="mbr-text ads-name-text mbr-fonts-style display-9 text-right">
                      Approval
                    </p>
                    <h5 className="item-title mbr-fonts-style display-7 text-right">
                      <strong
                        style={
                          this.props.data.status > 0
                            ? this.props.data.status === 1
                              ? { color: "green" }
                              : { color: "red" }
                            : { color: "black" }
                        }
                      >
                        {this.props.data.status > 0
                          ? this.props.data.status === 1
                            ? "Approved"
                            : "Not Approved"
                          : "Pending"}
                      </strong>
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="row">
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Remaning Days (Approx.)
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    <strong>
                      {this.state.remainingdates <= 0
                        ? Math.floor(
                            Math.abs(
                              this.state.remainingdates / (1000 * 60 * 60 * 24)
                            )
                          )
                        : "Unknown"}
                    </strong>
                  </h5>
                </div>
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    People Reached (Approx.)
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.totalServedAmount}
                  </h5>
                </div>
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Routes Covered
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.totalNumberOfAdsServed}
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Paid Fee
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.amountPaid !== null &&
                    this.props.data.amountPaid !== undefined
                      ? numberWithCommas(
                          this.props.data.amountPaid.toFixed(2)
                        ) + " ETB"
                      : "-"}
                  </h5>
                </div>
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Refund
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.refund !== null &&
                    this.props.data.refund !== undefined
                      ? numberWithCommas(this.props.data.refund.toFixed(2)) +
                        " ETB"
                      : "-"}
                  </h5>
                </div>
                <div className="сol-4 col-md-4 col-sm-4">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9">
                    Net Cost
                  </p>
                  <h5 className="item-title mbr-fonts-style display-7">
                    {this.props.data.amountPaid !== null &&
                    this.props.data.refund !== null &&
                    this.props.data.refund !== undefined &&
                    this.props.data.amountPaid !== undefined
                      ? numberWithCommas(
                          (
                            this.props.data.amountPaid - this.props.data.refund
                          ).toFixed(2)
                        ) + " ETB"
                      : "-"}
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="col"></div>
                <div className="col">
                  <p className="mbr-text mbr-fonts-style mt-3 display-7 col-12 text-right">
                    <a
                      href={"/business_ad/" + this.props.data.id}
                      rel="noreferrer"
                      target="_blank"
                      className="text-primary"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      More..
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
    adcard: state.adcard,
  };
};

export default connect(mapStateToProps)(BusinessADHistoryComponent);
